export const SIDE_NAV_WIDTH = 280;
